/* ========================================================================== */
/* File: src/components/layout/Sidebar.js (Updated)             */
/* ========================================================================== */
import React from 'react';
import { LayoutDashboard, Building, HardDrive, Users, Settings, BarChart2, DollarSign, EarthIcon, HeartPlusIcon, Microscope } from 'lucide-react';
import companyLogo from '../../assets/logo.png';

const NavLink = ({ view, activeView, icon, children, onClick }) => (
    <a
      href="#"
      onClick={(e) => { e.preventDefault(); onClick(view); }}
      className={`nav-link ${activeView === view ? 'active' : ''}`}
    >
      {React.cloneElement(icon, { size: 20 })}
      <span>{children}</span>
    </a>
);

const Sidebar = ({ user, activeView, setActiveView, isOpen }) => {
    return (
        <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-logo">
                <img src={companyLogo} alt="Your Company Logo"/>
            </div>
            <nav className="sidebar-nav">

                {/* --- TOP NAVIGATION GROUP --- */}
                <div className="nav-group-top">
                    <NavLink view="dashboard" activeView={activeView} onClick={setActiveView} icon={<LayoutDashboard />} >Dashboard</NavLink>
                    <NavLink view="properties" activeView={activeView} onClick={setActiveView} icon={<Building />} >Properties</NavLink>
                    <NavLink view="reports" activeView={activeView} onClick={setActiveView} icon={<BarChart2 />} >Reports</NavLink>
                    {user && user.role === 'SuperAdmin' && (
                        <NavLink view="eventLogs" activeView={activeView} onClick={setActiveView} icon={<Microscope />} >Event Logs</NavLink>
                    )}
                    <NavLink view="billing" activeView={activeView} onClick={setActiveView} icon={<DollarSign />} >Billing</NavLink>
                    <NavLink view="domains" activeView={activeView} onClick={setActiveView} icon={<EarthIcon />} >Domains</NavLink>                   
                </div>

                {/* --- BOTTOM NAVIGATION GROUP --- */}
                <div className="nav-group-bottom">
                    <NavLink view="support" activeView={activeView} onClick={setActiveView} icon={<HeartPlusIcon />} >Support</NavLink>
                    <NavLink view="settings" activeView={activeView} onClick={setActiveView} icon={<Settings />} >Settings</NavLink>
                </div>
                
                
            </nav>
        </aside>
    );
};

export default Sidebar;